type Listener = (enabled: boolean) => void;

let offlineEnabled = false;
const listeners = new Set<Listener>();

export const setRuntimeOfflineEnabled = (enabled: boolean) => {
  if (offlineEnabled === enabled) return;
  offlineEnabled = enabled;
  listeners.forEach((listener) => {
    try {
      listener(enabled);
    } catch (error) {
      console.warn("Offline runtime listener threw", error);
    }
  });
};

export const isRuntimeOfflineEnabled = () => offlineEnabled;

export const subscribeOfflineRuntime = (listener: Listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
